var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "grey padding10",
          attrs: { "label-position": "left", "label-width": "auto" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "销售渠道" } }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.orderInfo.zplatOrder === 0
                            ? "美团"
                            : _vm.orderInfo.zplatOrder === 1
                            ? "京东到家"
                            : _vm.orderInfo.zplatOrder === 2
                            ? "饿了么"
                            : "tops"
                        )
                      ),
                    ]),
                  ]),
                  _c("el-form-item", { attrs: { label: "商家实收" } }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.orderInfo.noriginPrice
                            ? (_vm.orderInfo.noriginPrice / 100).toFixed(2)
                            : "0"
                        ) + "元"
                      ),
                    ]),
                  ]),
                  _c("el-form-item", { attrs: { label: "订单状态" } }, [
                    _c(
                      "p",
                      {
                        class: [
                          _vm.calculateTimeDifferenceInMinutes(
                            _vm.orderInfo.tarriveReq
                          ).timeDifference > 0
                            ? "overdue-time"
                            : "remaining-time",
                        ],
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.calculateTimeDifferenceInMinutes(
                                _vm.orderInfo.tarriveReq
                              ).displayText
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c("el-form-item", { attrs: { label: "收货地址" } }, [
                    _c("p", [_vm._v(_vm._s(_vm.orderInfo.creceiveAddr))]),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-form-item", { attrs: { label: "预定人" } }, [
                    _c("p", [_vm._v(_vm._s(_vm.orderInfo.ccustomerName))]),
                  ]),
                  _c("el-form-item", { attrs: { label: "手机号码" } }, [
                    _c("p", [_vm._v(_vm._s(_vm.orderInfo.ccustomerPhone))]),
                  ]),
                  _c("el-form-item", { attrs: { label: "用户备注" } }, [
                    _c("p", [_vm._v(_vm._s(_vm.orderInfo.corderRemark))]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { padding: "0 20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.tabActive,
                callback: function ($$v) {
                  _vm.tabActive = $$v
                },
                expression: "tabActive",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "松鼠屋(" + _vm.underPrice.ssw + ")",
                    name: "0",
                  },
                },
                [
                  _c("deliveryTabSsw", {
                    attrs: { "order-info": _vm.orderInfo },
                    on: {
                      handleConfirm: _vm.handleConfirm,
                      handleClose: _vm.handleClose,
                      handleUnderPrice: _vm.handleUnderPrice,
                    },
                  }),
                ],
                1
              ),
              _c("el-tab-pane", {
                attrs: { label: "抖送(" + _vm.underPrice.ds + ")", name: "1" },
              }),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "快服务(" + _vm.underPrice.kfw + ")",
                    name: "2",
                  },
                },
                [
                  _c("deliveryTabKfw", {
                    attrs: { "order-info": _vm.orderInfo },
                    on: {
                      handleConfirm: _vm.handleConfirm,
                      handleClose: _vm.handleClose,
                      handleUnderPrice: _vm.handleUnderPrice,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "真省钱(" + _vm.underPrice.zsq + ")",
                    name: "3",
                  },
                },
                [
                  _c("deliveryTabZsq", {
                    attrs: { "order-info": _vm.orderInfo },
                    on: {
                      handleConfirm: _vm.handleConfirm,
                      handleClose: _vm.handleClose,
                      handleUnderPrice: _vm.handleUnderPrice,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "美团跑腿(" + _vm.underPrice.mtpt + ")",
                    name: "5",
                  },
                },
                [
                  _c("deliveryTabMtpt", {
                    attrs: { "order-info": _vm.orderInfo },
                    on: {
                      handleConfirm: _vm.handleConfirm,
                      handleClose: _vm.handleClose,
                      handleUnderPrice: _vm.handleUnderPrice,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "美团配送(" + _vm.underPrice.mtps + ")",
                    name: "6",
                  },
                },
                [_vm._v("c")]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "巨莱昂配送(" + _vm.underPrice.jla + ")",
                    name: "7",
                  },
                },
                [_vm._v("c")]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "自配送(" + _vm.underPrice.self + ")",
                    name: "8",
                  },
                },
                [_vm._v("c")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }